import { AppointmentAthleteRetrieve } from 'types';

import { useAppointmentStats, UseAppointmentStats } from './useAppointmentStats';
import { useAppointmentTiming, UseAppointmentTiming } from './useAppointmentTiming';

export type AppointmentMeta = UseAppointmentTiming & UseAppointmentStats;

export function useAppointmentMeta(appointment: AppointmentAthleteRetrieve | undefined): AppointmentMeta {
  const timing = useAppointmentTiming(appointment);
  const counts = useAppointmentStats(appointment);

  return {
    ...timing,
    ...counts,
  };
}
